import { Config } from "src/Utils/ConfigService/LoadConfig";
import { usePostRequest } from "../ApiWrappers/usePostRequest";
import { useCallback, useEffect, useRef, useState } from "react";
import { v1 } from "src/Utils/ApiVersions";
import { logger } from "src/Utils/LoggerService/LoggerService";


export enum PromoCodeWarning{
    NONE = "NONE",
    INVALID = "INVALID",
    ALREADY_USED = "ALREADY_USED",
    EXPIRED = "EXPIRED",
    NOT_ACTIVE = "NOT_ACTIVE"
}
export interface IAddCouponCreditsResponse {
    amount?: string;
    warning?: PromoCodeWarning;
}


export const useAddCouponCredits = () => {
    const [couponCreditsResponse, setCouponCreditsResponse] = useState<IAddCouponCreditsResponse>();
    const {postRequest, reqestResponse, reqestError, reqestLoading} = usePostRequest();
    const baseUrl = Config.GetConfigData().auraLicensingService.serviceUrl;
    const clinicIdRef = useRef<string>('');
    const addCouponCredits = useCallback((creditCoupon: string, clinicId: string) => {
        const requestUrl = `${baseUrl}api/${v1}/payment/clinic/${clinicId}/customer/credit`;
        logger.logInformation(`Request to add customer credit to given clinic ${clinicId} was made`);
        postRequest<string>(creditCoupon, requestUrl);
        clinicIdRef.current = clinicId;
    }, [baseUrl, postRequest]);
   
    useEffect(() => {
        if (reqestResponse) {
            setCouponCreditsResponse({ warning: reqestResponse.warning , amount: reqestResponse.amount });
        }
    }, [reqestResponse]);

    return {couponCreditsResponse, reqestError, reqestLoading, addCouponCredits};
}
